import React from 'react'
import './reviews.css'
import Wave from '../wave/Wave'

const REVIEWS = [
  {
    name: 'Chanel V.',
    text: 'Great School! Awesome Teachers! Great Staff! My daughter has been going here since she was 10 months old when they had and infant room. They have always treated her with love and kindness. She loves her school and her father and I do too. It is super clean, well maintained, staffing standards are next level. Just an overall awesome, well run establishment. Highly recommend.',
  },
  {
    name: 'Nicole S.',
    text: 'Signed my daughter up at the end of August this year when she turned one. Me and my husband have seen a huge improvement in her growth since she started here. They are great at communication and keep me informed about everything. They have a healthy hot lunch program, yoga, spanish, sign language, music time, etc. I highly recommend this school.',
  },
  {
    name: 'Lacey T.',
    text: 'Love this school! Really glad I enrolled both my boys here! Its such a great atmosphere! The kids love going everyday, and the growth displayed has been incredible! The teachers are really great with communication and the Director is so kind and personable! She keeps us informed with pictures of daily activities and weekly learning plans!',
  },
]

export default function Reviews() {
  return (
    <section className="reviews-section">
      <div className="reviews-head">
        <span className="section-eyebrow">Kind words</span>
        <h2 className="section-title">Parents love us</h2>
      </div>
      <div className="reviews-list">
        {REVIEWS.map((r, i) => (
          <figure className={`review r${i % 3}`} key={r.name}>
            <span className="review-quote" aria-hidden="true">“</span>
            <blockquote>{r.text}</blockquote>
            <figcaption>
              <span className="review-stars" role="img" aria-label="Five stars">★★★★★</span>
              <span className="review-name">{r.name}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <Wave color="var(--cream)" />
    </section>
  )
}
